import { render, staticRenderFns } from "./pt-BR.vue?vue&type=template&id=45286c28&"
import script from "./pt-BR.vue?vue&type=script&lang=js&"
export * from "./pt-BR.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45286c28')) {
      api.createRecord('45286c28', component.options)
    } else {
      api.reload('45286c28', component.options)
    }
    module.hot.accept("./pt-BR.vue?vue&type=template&id=45286c28&", function () {
      api.rerender('45286c28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/Languages/pt-BR.vue"
export default component.exports